import { render, staticRenderFns } from "./YandexMetrica.vue?vue&type=template&id=a565f14c&"
import script from "./YandexMetrica.vue?vue&type=script&lang=js&"
export * from "./YandexMetrica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports